import React from 'react';
import Error from './Error';
import { Trans } from '@lingui/macro';

function NotFound() {
  const message =
    <Trans>
      Hello! You have reached the nothingness. In case you are lost, hopefully we can get you back to a safe place.
      <br /><br />
      If you are not lost, and this is an error... sorry! Still, please follow the link below because that's all you can do at this point.
    </Trans>;

  const action = {
    link: "/",
    text: <Trans>GO TO HOMEPAGE</Trans>
  };

  return <Error title={<Trans>404 - PAGE NOT FOUND</Trans>} message={message} action={action} />
}

export default NotFound;
